import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

import ScrollToTop from './components/ScrollToTop';
import TabBar from './components/TabBar';
import ErrorComponent from './components/Error';

// Pages
import Home from './pages/Home';
import Tips from './pages/Tips';
import CampusMap from './pages/CampusMap';
import News from './pages/News';
import NewsDetails from './pages/NewsDetails';
import Arsenal from './pages/Arsenal';
import ArsenalDetails from './pages/ArsenalDetails';
import Events from './pages/Events';
import EventsDetails from './pages/EventsDetails';
import BeResponsible from './pages/BeResponsible';
import Bunker from './pages/Bunker';
import Sport from './pages/Sport';
import Animation from './pages/Animation';
import Emergency from './pages/Emergency';
import Contacts from './pages/Contacts';

// Components
import FullScreenPopup from './components/FullScreenPopup';


function Analytics() {
    const location = useLocation();

    useEffect(() => {
        ReactGA.initialize('G-2FND2XHFFE', {
            gaOptions: { anonymize_ip: true },
        });
    }, []);

    useEffect(() => {
        ReactGA.send({
            hitType: 'pageview',
            page: location.pathname,
            title: document.title,
        });
    }, [location]);

    return null;
}


function App() {

    const routes = [
        { path: '/', element: <Home /> },
        { path: '/tips', element: <Tips /> },
        { path: '/plan-campus', element: <CampusMap /> },
        { path: '/actualites', element: <News /> },
        { path: '/actualites/:newsId', element: <NewsDetails /> },
        { path: '/arsenal', element: <Arsenal /> },
        { path: '/arsenal/:menu', element: <ArsenalDetails /> },
        { path: '/events', element: <Events /> },
        { path: '/events/:eventsId', element: <EventsDetails /> },
        { path: '/be-responsible', element: <BeResponsible /> },
        { path: '/bunker', element: <Bunker /> },
        { path: '/sport', element: <Sport /> },
        { path: '/animation', element: <Animation /> },
        { path: '/urgence', element: <Emergency /> },
        { path: '/contacts', element: <Contacts /> },
        {
            path: '*',
            element: (
                <ErrorComponent
                    title="Erreur 404"
                    message="Cette page n'existe pas 🙈. Veuillez vérifier l'URL et réessayer à nouveau."
                />
            ),
        },
    ];

    const [isPopupClosed, setIsPopupClosed] = useState(false);

    return (
        <>
            {!isPopupClosed && (
                <FullScreenPopup
                    duration={86400000} // 24 hours
                    onClose={() => setIsPopupClosed(true)} // Switches to Home when the popup is closed
                />)}

            <Router>
                <Analytics />
                <ScrollToTop />
                <Routes>
                    {routes.map(({ path, element }) => (
                        <Route key={path} path={path} element={element} />
                    ))}
                </Routes>
                <TabBar />
            </Router>
        </>
    );
}

export default App;
